import React, { useContext } from "react";
import Labeled from "common/Labeled";
import TextInput from "common/TextInput";
import ActionsContext from "common/ActionsContext";
import ChoiceOrValue from "common/ChoiceOrValue";

const doesNothing = () => {};

const options = [
  { value: "0.0.0.0/0", label: "All IPv4" },
  { value: "::/0", label: "All IPv6" },
  { value: "spec", label: "Specify Address/Range:" },
];

export const AddressInput = ({
  name,
  defaultSelectValue = "spec",
  defaultValue = "",
  onChange = doesNothing,
}) => {
  const actions = useContext(ActionsContext);
  const sendAndChange = (address) => {
    actions.send("address-changed", address);
    onChange(address);
  };

  return (
    <ChoiceOrValue
      name={name}
      options={options}
      defaultValue={defaultValue}
      defaultSelectValue={defaultSelectValue}
      onChange={sendAndChange}
      ValueInput={TextInput}
      type="text"
    />
  );
};

export const LabeledAddressInput = ({ ...settings }) => (
  <Labeled {...settings}>
    <div className="margin-l-10 flex-100">
      <AddressInput {...settings} />
    </div>
  </Labeled>
);
export default LabeledAddressInput;
